import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetAccountNamePipe, IsAccountDeletedPipe, IsAccountLoadingPipe } from './account-name-getter.pipe';
import { AccountNameGetterService } from './account-name-getter.service';

@NgModule({
  declarations: [GetAccountNamePipe, IsAccountLoadingPipe, IsAccountDeletedPipe],
  imports: [CommonModule],
  providers: [AccountNameGetterService],
  exports: [GetAccountNamePipe, IsAccountLoadingPipe, IsAccountDeletedPipe],
})
export class AccountNameGetterModule {}
